import React, { Component } from 'react';
import { Pagination, Progress, Form, Input, Button, Table } from 'antd';
import { DatePicker, Select, ConfigProvider, Icon, Popover } from 'antd';
import { Breadcrumb, Tag, Checkbox, message, Spin } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import { apis } from '../api/index.js';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import moment from 'moment';
import i18n from 'i18next';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import TableEmpty from '../components/TableEmpty.js';
import { getSex, subscribeLocalStorage, formatDA } from '../utils';
import { breadBack, changeListWidth, getInstitutionOptions } from '../utils';
import { ReviewIcon, formatFromTime, formatToTime } from '../utils';
import { getProvinceOption, getDay, setScrollTop } from '../utils';
import { institutionRecord, getArea, calcTableHeight } from '../utils';
import { showMoreSearch, fastDateOption, breadItem, autoFresh } from '../utils';
import { setSearchInfo, loadingOptionsHtml, timeCalc } from '../utils';

import throttle from 'lodash.throttle';
const { Option } = Select;
let autoRefreshReview = '';

const initState = {
  page: 1,
  sortBy: '',
  sort: '',
  patName: '',
  timeTypeVal: false,
  defineTimeType: false,
  institutionId: false,
  doctorReviewStatus: undefined,
  areaProvince: undefined,
  chestStatus: undefined,
  recentDays: 2,
  uploadType: 11,
  dayRange: [getDay(-2) + ' 0:0:0', getDay(0) + ' 23:59:59'],
};

class ReviewForm extends Component {
  static propTypes = {
    form: PropTypes.object,
    server: PropTypes.object,
    history: PropTypes.object,
    onUserInfoUpdated: PropTypes.func,
    setApplicationData: PropTypes.func,
    setCurrentSearchInfoData: PropTypes.func,
    userInfo: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = initState;

    this.throttledAiHis = throttle(newState => {
      this.getAihis(newState);
    }, 1000);

    this.formResize = throttle(newState => {
      //页面大小改变，更新table高度
      const newHeight = calcTableHeight(189) || 0;
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
    }, 1000);
  }

  async componentDidMount() {
    const roleInfo = (this.props.userInfo.operationAuths || '').split(',');
    const isAnonymity = roleInfo.includes('S');
    this.setState({
      isAnonymity,
      roleInfo,
      tableHeight: 0,
      aihisList: [],
      total: 0,
      autoRefreshStatus: false,
      loadingIconShow: false,
      searchLoading: false,
      i18nextLng: 'zh-CN',
      listWidth: 'calc(87% - 8px)',
      moreFilter: true,
      showMoreFilter: false,
    });

    this.getProvinceList();
    this.getInstitutionData();
    subscribeLocalStorage(this.throttledAiHis);
    this.pageInit();

    window.addEventListener('resize', () => {
      this.formResize();
    });
    this.formResize();
  }

  componentDidUpdate() {}

  pageInit = () => {
    const api = window.store.getState().api;
    const searchInfo = api.current.searchInfo;
    const state = searchInfo.reviewlist;
    state.defineTimeType = state.timeTypeVal;
    const newState = Object.assign({}, initState, state);
    this.throttledAiHis(newState);

    //从内在中读取是否开启自动刷新
    api.current.searchInfo = api.current.searchInfo || {};
    const status = api.current.searchInfo.autoRefreshStatus || false;
    this.reFreshList(status);
  };

  //自动刷新列表
  reFreshList = status => {
    this.setState({ autoRefreshStatus: status });
    const _this = this;
    if (status) {
      autoRefreshReview = setInterval(function() {
        if (!document.getElementById('reviewForm')) {
          clearInterval(autoRefreshReview);
        } else {
          const newState = { page: _this.state.page };
          _this.throttledAiHis(newState);
        }
      }, 10000);
    } else {
      clearInterval(autoRefreshReview);
    }
  };

  //获取列表
  getAihis = newState => {
    const rows = 20;
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);

    const post = {
      offset: (updatedState.page - 1) * rows,
      rows,
      institutionId: updatedState.institutionId,
      sortBy: updatedState.sortBy,
      sort: updatedState.sort,
      patName: encodeURI(updatedState.patName),
      aiProductType: updatedState.uploadType,
      doctorReviewStatus: updatedState.doctorReviewStatus,
      doctorResult: '',
      isDoctorReview: '1',
      areaProvince: updatedState.areaProvince,
      chestpa: updatedState.chestStatus,
    };
    if (updatedState.defineTimeType) {
      const dayRange = updatedState.dayRange;
      post.fromTime = dayRange ? formatFromTime(dayRange) : null;
      post.toTime = dayRange ? formatToTime(dayRange) : null;
    } else {
      if (updatedState.recentDays !== undefined) {
        const dayRange = timeCalc(updatedState.recentDays);
        post.fromTime = dayRange.fromTime;
        post.toTime = dayRange.toTime;
      } else {
        post.fromTime = undefined;
        post.toTime = undefined;
      }
    }
    apis.studyRecord(post).then(result => {
      this.setState({ loadingIconShow: false, searchLoading: false });
      if (result.code === '0') {
        this.setState({
          aihisList: result.data.list,
          total: result.data.total,
        });
      } else {
        if (result.code === '1009') this.props.history.push('/login');
        this.setState({ aihisList: [], total: 0 });
      }
    });
  };

  //查看详情
  viewHeatmap = item => {
    this.props.setApplicationData(item);

    const studyUid = item.studyUid;
    const id = item.id;
    let status = item.doctorReviewStatus;
    if (status === '0') status = '1';
    else if (status === '1') status = '2';
    if (status === '0' || status === '1') {
      this.setState({ isLoading: true });
      apis.setDoctorReviewStatus4Study(id, status).then(res => {
        this.setState({ isLoading: false });
        this.throttledAiHis();
        if (res.code === '0') this.toViewer(studyUid, id);
        else {
          message.error(res.message);
          if (res.code === '1009') this.props.history.push('/login');
        }
      });
    } else {
      this.toViewer(studyUid, id);
    }
  };

  toViewer = (study_uid, id) => {
    const { uploadType } = this.state;
    const w = window.screen.width - 10;
    const h = window.screen.height - 105;
    const url = `/viewer/study/${study_uid}?from=aiproduct&id=${id}&type=${uploadType}&from1=aireview`;
    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${w},height=${h}`;
    window.open(url, 'viewer', str);
  };

  //点击搜索按钮
  handleSearch = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const newState = {
          institutionId: (values.name || []).join(','),
          patName: values.patName,
          doctorReviewStatus: values.status,
          page: 1,
          loadingIconShow: true,
          searchLoading: true,
          areaProvince: values.provice,
          chestStatus: values.chestStatus,
          dayRange: values.dayRange,
          recentDays: values.recentDays,
          defineTimeType: this.state.timeTypeVal,
          timeTypeVal: this.state.timeTypeVal,
        };

        this.throttledAiHis(newState);
        setSearchInfo(newState, 'reviewlist', this);
        setScrollTop();
      }
    });
  };

  //点击重置按钮
  handleReset = () => {
    const loadingState = { searchLoading: true };
    const newState = Object.assign({}, initState, loadingState);
    this.setState(newState);
    this.props.form.resetFields();
    this.getInstitutionData();
    this.throttledAiHis(newState);
    setSearchInfo(initState, 'reviewlist', this);
    setScrollTop();
  };

  getStatusName = status => {
    const statusArray = [
      { value: '0', label: '待审核', color: '#F4A237' },
      { value: '1', label: '审核中', color: '#5EC8DD' },
      { value: '2', label: '已审核', color: '#78C493' },
      { value: '3', label: '已打印', color: '#78C493' },
      { value: '-1', label: '未开通', color: '#999999' },
    ];
    let tagHtml;
    statusArray.forEach(item => {
      if (item.value === status)
        tagHtml = <Tag color={item.color}>{item.label}</Tag>;
    });
    return tagHtml;
  };
  handleChangeSelect = (id, value) => {
    const newData = [...this.state.aihisList];
    const index = newData.findIndex(item => id === item.id);
    if (index > -1) {
      const changedData = newData[index];
      changedData.part = value;
      newData[index] = changedData;
      this.setState({ aihisList: newData });
    }
  };
  //获取是否是正位胸片
  getChestPa = list => {
    if (list.isContainsChestPa === '0') {
      //其他部位
      return <span className="text-tag-other">其他部位</span>;
    } else if (list.isContainsChestPa === '1') {
      //正位胸片+其他部位
      return (
        <Select
          style={{ width: 90 }}
          size="small"
          value={list.part || 'chestPa'}
          onChange={this.handleChangeSelect.bind(this, list.id)}
        >
          <Option key={0} value="chestPa">
            正位胸片
          </Option>
          <Option key={1} value="other">
            其他部位
          </Option>
        </Select>
      );
    } else if (list.isContainsChestPa === '2') {
      //正位胸片
      return <span className="text-tag-chestpa">{i18n.t('chestPA')}</span>;
    } else {
      return <span>--</span>;
    }
  };

  //分页
  pageOnChange = (page, pageSize) => {
    setScrollTop();
    const newState = { page, searchLoading: true };
    this.throttledAiHis(newState);
  };

  //获取机构列表
  getInstitutionData = async (name, area) => {
    const data = await institutionRecord(name, area);
    this.setState({ institutionData: data });
  };

  //机构下拉的查询功能
  handleInstitutionSearch = value => {
    const area = this.state.areaProvince;
    this.getInstitutionData(value, area);
  };

  getReviewedStatusDetail = list => {
    if (list.isContainsChestPa === '0') {
      return <span>--</span>;
    } else {
      const contentHtml = (
        <div className="popover-width">{list.reviewedStatusDetail}</div>
      );
      if (list.reviewedStatusDetail) {
        return (
          <Popover
            placement="bottomLeft"
            content={contentHtml}
            title={i18n.t('impressionR')}
          >
            <span>{this.getStatusName(list.doctorReviewStatus)}</span>
          </Popover>
        );
      } else {
        return <span>{this.getStatusName(list.doctorReviewStatus)}</span>;
      }
    }
  };

  getColumns = () => {
    const { sortBy, sort, isAnonymity } = this.state;
    const columns = [];
    let isBig = false;
    let tableWidth = 1460;
    const screenWidth = document.body.clientWidth * 0.87 - 55;
    if (screenWidth > tableWidth) isBig = true;
    columns.push(
      {
        title: '姓名',
        dataIndex: 'patName',
        key: 'patName',
        width: isBig ? 200 : 170,
        render: patName => (isAnonymity ? '***' : patName),
      },
      {
        title: '年龄',
        dataIndex: 'patAge',
        key: 'patAge',
        width: isBig ? 100 : 80,
        render: patAge => (isAnonymity ? '***' : patAge),
      },
      {
        title: '性别',
        dataIndex: 'patSex',
        key: 'patSex',
        width: isBig ? 100 : 80,
        render: patSex => (isAnonymity ? '***' : getSex(patSex)),
      },
      {
        title: '部位',
        dataIndex: '',
        key: 'isContainsChestPa',
        width: 180,
        render: list => <div>{this.getChestPa(list)}</div>,
      },
      {
        title: '异常疑似度',
        dataIndex: '',
        key: 'abnormal',
        sorter: true,
        sortDirections: ['ascend', 'descend'],
        defaultSortOrder: sortBy === 'abnormal' ? sort : '',
        width: 180,
        render: list => {
          if (list.isContainsChestPa === '0' || list.part === 'other')
            return <span>--</span>;
          let value = list.abnormalConfidence11 || 0;
          const abnormal = parseFloat((value * 100).toFixed(1));

          return (
            <Progress
              strokeColor={abnormal <= 50 ? '#2F7BFF' : '#DC2F2F'}
              percent={abnormal}
              status="active"
              strokeWidth={5}
              style={{ width: 50 }}
            />
          );
        },
      },
      {
        title: '审核状态',
        dataIndex: '',
        key: 'resultCode',
        width: 120,
        render: list => {
          return list.isContainsChestPa === '0' ? (
            <span>--</span>
          ) : (
            <span>{this.getReviewedStatusDetail(list)}</span>
          );
        },
      },
      {
        title: '审核医生',
        dataIndex: '',
        key: 'reviewedDoctorName',
        width: 100,
        render: list => (
          <span>
            {list.isContainsChestPa === '0' ? '--' : list.reviewedDoctorName}
          </span>
        ),
      },
      {
        title: '上传时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 200,
        render: createTime => <span>{formatDA(createTime)}</span>,
      },
      {
        title: '机构',
        dataIndex: 'institutionName',
        key: 'institutionName',
        render: value => <span>{isAnonymity ? '***' : value}</span>,
      },
      {
        title: '操作',
        key: 'id',
        align: 'center',
        width: 150,
        fixed: 'right',
        render: list => <>{this.getButtons(list)}</>,
      }
    );

    return columns;
  };
  getButtons = record => {
    const { roleInfo } = this.state;
    const userId = this.props.userInfo.id;
    const boxUserId = record.doctorReviewBoxUserId;
    const status = record.doctorReviewStatus;

    const buttons = [];
    if (status === '0' && roleInfo.includes('V')) {
      buttons.push(
        <Button
          type="link"
          key={0}
          className="btn-viewdetail"
          disabled={record.isContainsChestPa === '0' ? true : false}
          onClick={this.viewHeatmap.bind(this, record)}
        >
          <ReviewIcon />
          审核
        </Button>
      );
    } else if (status === '1' && boxUserId === userId) {
      buttons.push(
        <Button
          type="link"
          key={0}
          className="btn-viewdetail"
          disabled={record.isContainsChestPa === '0' ? true : false}
          onClick={this.viewHeatmap.bind(this, record)}
        >
          <ReviewIcon />
          审核
        </Button>
      );
    } else if ((status === '2' && roleInfo.includes('E')) || status === '3') {
      buttons.push(
        <Button
          type="link"
          key={0}
          className="btn-viewdetail"
          disabled={record.isContainsChestPa === '0' ? true : false}
          onClick={this.viewHeatmap.bind(this, record)}
        >
          <Icon type="eye" theme="filled" />
          查看
        </Button>
      );
    } else {
      buttons.push(
        <Button type="link" key={0} className="btn-viewdetail" disabled={true}>
          <Icon type="eye" theme="filled" />
          查看
        </Button>
      );
    }
    return buttons;
  };

  handleChangeProvince = value => {
    this.setState({ areaProvince: value });
    this.getInstitutionData('', value);
  };
  // 获取省份列表
  getProvinceList = async () => {
    const data = await getArea(0);
    this.setState({ provinceList: data });
  };
  setTimeType = e => {
    this.setState({ timeTypeVal: e.target.checked });
  };
  setFreshEvent = e => {
    // if (e.target.checked) this.setSearchEvent('ns-062');
    // else this.setSearchEvent('ns-063');
  };
  setBackEvent = () => {
    // this.setSearchEvent('ns-066');
  };
  setStateEvent = () => {};
  render() {
    let { isLoading, moreFilter, showMoreFilter } = this.state;
    let { chestStatus, patName, doctorReviewStatus, dayRange } = this.state;
    let { tableHeight, recentDays, areaProvince, institutionId } = this.state;
    let { aihisList, institutionData, timeTypeVal, isAnonymity } = this.state;

    institutionId = institutionId ? institutionId.split(',') : [];
    institutionId = institutionId.map(item => +item);

    const { RangePicker } = DatePicker;
    const dateFormat = 'YYYY-MM-DD';

    const columns = this.getColumns();

    const { getFieldDecorator } = this.props.form;
    const institutionOptions = getInstitutionOptions(institutionData, 'id');

    let tableWidth = 1460;
    const screenWidth = document.body.clientWidth * 0.87 - 55;
    if (screenWidth > tableWidth) tableWidth = screenWidth;

    const loadingOptions = loadingOptionsHtml(this.state.searchLoading);

    const from = formatFromTime(dayRange);
    const to = formatToTime(dayRange);

    const chestOptions = [
      { label: '正位胸片', value: '1' },
      { label: '其他部位', value: '0' },
    ];
    const statusOptions = [
      { label: '待审核', value: '0' },
      { label: '审核中', value: '1' },
      { label: '已审核', value: '2' },
      { label: '已打印', value: '3' },
    ];
    return (
      <div className="form-bg" id="reviewForm">
        {isLoading && (
          <div className="spin-box-bg">
            <Spin indicator={<Icon type="loading" spin />} />
          </div>
        )}
        <ConnectedMenu toggleCollapsed={changeListWidth.bind(this, this)} />
        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={changeListWidth.bind(this, this)}
            login={false}
            home={true}
          />

          <div className="theme-box">
            <div className="bread-crumb">
              <Breadcrumb>{breadItem(['AI应用审核', '审核列表'])}</Breadcrumb>
              {breadBack(this)}
              {autoFresh(this)}
            </div>

            <div className="box" style={{ width: this.state.listWidth }}>
              <div className="left">
                <Form
                  className={`ant-advanced-search-form${
                    !moreFilter && showMoreFilter ? ' notOverflow' : ''
                  }`}
                  onSubmit={this.handleSearch}
                  layout="inline"
                >
                  <div className="searchBox">
                    <div className="searchBoxContent">
                      <div className="search-unit">
                        <Form.Item
                          style={{
                            display: timeTypeVal === true ? '' : 'none',
                          }}
                          label="上传时间"
                          colon={false}
                        >
                          <ConfigProvider locale={zh_CN}>
                            {getFieldDecorator('dayRange', {
                              initialValue:
                                from && to
                                  ? [
                                      moment(from, dateFormat),
                                      moment(to, dateFormat),
                                    ]
                                  : null,
                            })(
                              <RangePicker
                                format={dateFormat}
                                allowClear={true}
                                placeholder={['开始时间', '结束时间']}
                                style={{ width: 240 }}
                              />
                            )}
                          </ConfigProvider>
                        </Form.Item>
                        <Form.Item
                          style={{
                            display: timeTypeVal === true ? 'none' : '',
                          }}
                          label="上传时间"
                          colon={false}
                        >
                          {getFieldDecorator('recentDays', {
                            initialValue: recentDays,
                          })(
                            <Select
                              defaultActiveFirstOption={true}
                              showArrow={false}
                              filterOption={false}
                              allowClear={true}
                              style={{ width: 240 }}
                            >
                              {fastDateOption()}
                            </Select>
                          )}
                        </Form.Item>
                        <Form.Item label="" colon={false}>
                          {getFieldDecorator('defineTimeType', {})(
                            <Checkbox
                              checked={timeTypeVal}
                              onChange={this.setTimeType}
                            >
                              自定义
                            </Checkbox>
                          )}
                        </Form.Item>
                      </div>
                      <div className="search-unit">
                        <Form.Item
                          label="机构"
                          colon={false}
                          className="form-provice"
                        >
                          {getFieldDecorator('provice', {
                            initialValue: areaProvince,
                          })(
                            <Select
                              showSearch
                              placeholder="选择省份"
                              defaultActiveFirstOption={false}
                              filterOption={false}
                              showArrow={false}
                              onChange={this.handleChangeProvince}
                              notFoundContent={null}
                              allowClear={true}
                              style={{ width: 150 }}
                              disabled={isAnonymity}
                            >
                              {getProvinceOption(this.state.provinceList)}
                            </Select>
                          )}
                        </Form.Item>

                        <Form.Item
                          label=""
                          colon={false}
                          className="form-institute"
                        >
                          {getFieldDecorator('name', {
                            initialValue: institutionId,
                          })(
                            <Select
                              className="institution-selection"
                              showSearch
                              mode="multiple"
                              placeholder="请选择机构名称"
                              defaultActiveFirstOption={false}
                              showArrow={false}
                              filterOption={false}
                              onSearch={this.handleInstitutionSearch}
                              onChange={this.handleChange}
                              allowClear={true}
                              style={{ width: 220 }}
                              disabled={isAnonymity}
                            >
                              {institutionOptions}
                            </Select>
                          )}
                        </Form.Item>
                      </div>
                      <Form.Item label="部位" colon={false}>
                        {getFieldDecorator('chestStatus', {
                          initialValue: chestStatus,
                        })(
                          <Select
                            allowClear={true}
                            placeholder="请选择部位"
                            style={{ width: 160 }}
                          >
                            {chestOptions.map((item, index) => (
                              <Option value={item.value} key={index}>
                                {item.label}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="姓名" colon={false}>
                        {getFieldDecorator('patName', {
                          initialValue: patName,
                        })(
                          <Input
                            allowClear={true}
                            style={{ width: 160 }}
                            placeholder="请输入患者姓名"
                            disabled={isAnonymity}
                          />
                        )}
                      </Form.Item>
                      <Form.Item label="状态" colon={false}>
                        {getFieldDecorator('status', {
                          initialValue: doctorReviewStatus,
                        })(
                          <Select
                            placeholder="请选择状态"
                            allowClear={true}
                            style={{ width: 160 }}
                          >
                            {statusOptions.map((item, index) => (
                              <Option value={item.value} key={index}>
                                {item.label}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </div>
                  </div>
                  <div className="searchOptBox">
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn-search"
                        disabled={this.state.searchLoading}
                        // onClick={() => this.setSearchEvent('ns-064')}
                      >
                        {this.state.loadingIconShow ? (
                          <Icon type="sync" spin />
                        ) : (
                          <Icon type="search" />
                        )}
                        搜索
                      </Button>
                      <Button
                        style={{ marginLeft: 8 }}
                        icon="redo"
                        className="btn-reset"
                        disabled={this.state.searchLoading}
                        onClick={this.handleReset}
                      >
                        重置
                      </Button>
                    </Form.Item>
                    {this.state.showMoreFilter && (
                      <Button
                        type="link"
                        className="moreFilter"
                        onClick={() => {
                          this.setState({ moreFilter: !moreFilter });
                        }}
                        icon={moreFilter ? 'down' : 'up'}
                      >
                        {moreFilter ? '展开' : '收起'}
                      </Button>
                    )}
                  </div>
                </Form>
                <div className="history-list">
                  <Table
                    loading={loadingOptions}
                    columns={columns}
                    dataSource={aihisList}
                    rowKey={record => record.id}
                    pagination={false}
                    className="list-item"
                    scroll={{ x: tableWidth, y: tableHeight }}
                    locale={{ emptyText: <TableEmpty /> }}
                    onChange={(pagination, filters, sorter) => {
                      const orderType = { descend: 'DESC', ascend: 'ESC' };
                      const sortType = orderType[sorter.order];
                      const orderField = sorter.columnKey || '';
                      const newState = {
                        page: 1,
                        sortBy: orderField,
                        sort: sortType,
                        searchLoading: true,
                      };
                      this.throttledAiHis(newState);
                    }}
                  />
                  <ConfigProvider locale={zh_CN}>
                    <Pagination
                      onChange={this.pageOnChange}
                      total={this.state.total}
                      pageSize={20}
                      className="list-page"
                      current={this.state.page}
                      showQuickJumper
                      size="small"
                      showTotal={() => `共${this.state.total}条`}
                    ></Pagination>
                  </ConfigProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Form.create()(ReviewForm));
